const texts = {
  categories: {
    ONE_ON_ONE_CORE: '1:1 Core',
    PROMO: 'Promo',
    ENTRY: 'Entry',
    LOW_TICKET: 'Low Ticket',
  },
  forTermThenMonthly: (n, monthlyAmount) => `for ${n} ${n === 1 ? 'month' : 'months'}, then ${monthlyAmount}/month`,
  forDuration: (duration) => `for ${duration}`,
  starts: 'Starts',
  ongoing: 'Ongoing',
  acceptUntil: 'Accept until',
  disabled: 'Disabled',
};

export default texts;
